var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('highcharts',{attrs:{"options":_vm.chartOptions}}):_c('v-progress-circular',{staticClass:"mb-5",staticStyle:{"margin-left":"50%"},attrs:{"indeterminate":"","color":"black","size":"80","width":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }